<template>
  <div class="source-block">
    <el-alert
      v-if="isShowAlert"
      class="mb10"
      :title="`当前您存储空间已经使用${current_storage}G，最大限制${show_storage}G`"
      type="success"
    ></el-alert>
    <div class="source-tbl-head">
      <el-upload
        v-if="isCanUpload"
        multiple
        action="https://upload.renrenjiang.cn/start"
        :show-file-list="false"
        accept=".jpg,.jpeg,.png,.gif,.bmp"
        :before-upload="(file) => uploadFile(file)"
      >
        <el-button @click="showUploadDialog" type="primary" size="small">
          上传图片
        </el-button>
      </el-upload>
      <el-button v-else @click="pageToUpload" type="primary" size="small">
        上传图片
      </el-button>
      <div class="head-right">
        <span class="head-text">上传时间：</span>
        <el-date-picker
          size="small"
          @change="changeDateRange"
          v-model="timerange"
          type="daterange"
          value-format="yyyy-MM-dd"
          class="head-datepicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-input
          @clear="reset"
          size="small"
          clearable
          v-model="params.keyword"
          class="head-keyword"
          placeholder="请输入素材名称"
        >
          <i
            @click="search"
            class="filter-search-icon el-icon-search el-input__icon"
            slot="suffix"
          ></i>
        </el-input>
      </div>
    </div>
    <div class="source-tbl-info">
      <div class="info-total">素材总量：{{ total }}</div>
      <div class="info-right">
        <el-dropdown @command="changeSort" class="info-dropdown">
          <div class="info-condition">
            <span v-if="params.sort_by === 'name_desc'">文件名称 (Z-A)</span>
            <span v-if="params.sort_by === 'name_asc'">文件名称 (A-Z)</span>
            <span v-if="params.sort_by === 'size_desc'">文件大小 (大-小)</span>
            <span v-if="params.sort_by === 'size_asc'">文件大小 (小-大)</span>
            <span v-if="params.sort_by === 'time_desc'">上传时间 (旧-新)</span>
            <span v-if="params.sort_by === 'time_asc'">上传时间 (新-旧)</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="name_asc">
              文件名称 (A-Z)
            </el-dropdown-item>
            <el-dropdown-item command="name_desc">
              文件名称 (Z-A)
            </el-dropdown-item>
            <el-dropdown-item command="size_desc">
              文件大小 (大-小)
            </el-dropdown-item>
            <el-dropdown-item command="size_asc">
              文件大小 (小-大)
            </el-dropdown-item>
            <el-dropdown-item command="time_asc">
              上传时间 (新-旧)
            </el-dropdown-item>
            <el-dropdown-item command="time_desc">
              上传时间 (旧-新)
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="show-tabs">
          <div class="tab-bar" :class="showType"></div>
          <div class="tab-block">
            <div
              @click="changeShowType('grid')"
              class="tab-item"
              :class="{ active: showType === 'grid' }"
            >
              卡片视图
            </div>
            <div
              @click="changeShowType('table')"
              class="tab-item"
              :class="{ active: showType === 'table' }"
            >
              列表视图
            </div>
          </div>
        </div>
        <!-- <el-radio-group v-model="showType" size="small">
          <el-radio-button label="grid">卡片视图</el-radio-button>
          <el-radio-button label="table">列表视图</el-radio-button>
        </el-radio-group> -->
      </div>
    </div>
    <div class="source-tbl-block">
      <div v-if="showType === 'grid'" class="source-grid">
        <div id="gridList" class="grid-list">
          <div
            v-for="(n, i) in list"
            v-bind:key="`${i}_${n.id}`"
            class="grid-item"
            :style="{
              width: width + 'px',
            }"
          >
            <div
              @click="showMediaViewer(i)"
              class="grid-item-cover"
              :style="{
                width: width + 'px',
                height: width + 'px',
              }"
            >
              <el-image fit="contain" class="cover-img" :src="n.url"></el-image>
              <div v-if="mode === 'normal'" class="cover-mask">
                <span @click.stop="editSource(n)" class="mask-btn">编辑</span>
                <div class="mask-divider"></div>
                <span @click.stop="moveSource(n)" class="mask-btn">移动</span>
                <div class="mask-divider"></div>
                <span @click.stop="deleteSource(n)" class="mask-btn">删除</span>
              </div>
            </div>
            <div class="grid-item-info">
              <div class="grid-item-title">
                <el-checkbox
                  v-model="n.selected"
                  @change="(e) => gridChange(e, i)"
                  class="grid-checkbox"
                >
                  <div class="title-text">{{ n.file_name }}</div>
                </el-checkbox>
              </div>
              <div class="grid-item-detail">
                <div class="detail-text">{{ n.info }}</div>
                <div class="detail-text">{{ n.file_size.formatsize() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-table
        v-if="showType === 'table'"
        :data="list"
        height="100%"
        ref="listTable"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="图片" width="340">
          <template slot-scope="scope">
            <div class="source-item">
              <div
                @click="showMediaViewer(scope.$index)"
                class="source-item-cover"
              >
                <el-image
                  fit="contain"
                  class="cover-img"
                  :src="scope.row.url"
                ></el-image>
                <!-- <div class="cover-play"></div> -->
              </div>
              <div class="source-item-info">
                <div class="source-item-name">{{ scope.row.file_name }}</div>
                <div class="source-item-dur">{{ scope.row.info }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="大小">
          <template slot-scope="scope">
            {{ scope.row.file_size.formatsize() }}
          </template>
        </el-table-column>
        <el-table-column label="上传时间">
          <template slot-scope="scope">
            <div>{{ new Date(scope.row.created_at).format("yyyy-MM-dd") }}</div>
            <div>{{ new Date(scope.row.created_at).format("HH:mm:ss") }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="上传者">
          <template slot-scope="scope">
            {{ scope.row.creator.nickname }}
          </template>
        </el-table-column>
        <el-table-column label="引用位置">
          <template>
            <el-button type="text">12</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="状态">
          <template>
            <div class="source-status">正常</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="增强保护">
          <template>-</template>
        </el-table-column> -->
        <el-table-column
          v-if="mode === 'normal'"
          label="操作"
          align="right"
          width="140"
        >
          <template slot-scope="scope">
            <el-button @click="editSource(scope.row)" type="text">
              编辑
            </el-button>
            <el-button @click="moveSource(scope.row)" type="text">
              移动
            </el-button>
            <el-button @click="deleteSource(scope.row)" type="text">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="source-tbl-bottom">
      <div class="bottom-btns">
        <span class="bottom-text">
          已选 {{ selecteds.length }}/{{ list.length }} 条
        </span>
        <template v-if="mode === 'normal'">
          <el-button
            @click="batchDeleteSource"
            type="infor"
            size="small"
            :disabled="!selecteds.length"
          >
            批量删除
          </el-button>
          <el-button
            @click="batchMoveSource"
            type="infor"
            size="small"
            :disabled="!selecteds.length"
          >
            批量移动
          </el-button>
          <!-- <el-button type="infor" size="small">批量下载</el-button> -->
          <el-button @click="moveAllSource" type="infor" size="small">
            全部移动
          </el-button>
        </template>
      </div>
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="params.page"
        :page-size="params.pageSize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-image-viewer
      v-if="mediaViewer.visible"
      :urlList="mediaViewer.images"
      :on-close="closeMediaViewer"
      :initialIndex="mediaViewer.index"
      :zIndex="99999"
    ></el-image-viewer>

    <el-dialog
      width="840px"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="uploadDialog.visible"
    >
      <div class="upload-dialog">
        <div class="dialog-head">
          <div class="dialog-head-title">上传图片</div>
          <div @click="closeUploadDialog" class="dialog-head-close"></div>
        </div>
        <div class="dialog-body padding flexed">
          <div class="upload-files">
            <div
              :key="i"
              class="file-item"
              v-for="(n, i) in uploadDialog.selecteds"
            >
              <el-image
                class="file-item-img"
                fit="contain"
                :src="n.url"
              ></el-image>
              <div v-if="n.status === 1" class="file-item-loading">
                <i class="el-icon-loading"></i>
              </div>
              <div v-if="n.status === 100" class="file-item-success">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-foot">
          <!-- this.uploadDialog.status -->
          <template v-if="uploadDialog.status === 'show'">
            <el-upload
              multiple
              action="https://upload.renrenjiang.cn/start"
              :show-file-list="false"
              class="dialog-upload-btn"
              accept=".jpg,.jpeg,.png,.gif,.bmp"
              :before-upload="(file) => uploadFile(file)"
            >
              <el-button size="small">添加图片</el-button>
            </el-upload>
            <el-button
              :disabled="uploadDialog.selecteds.length === 0"
              @click="startUpload"
              type="primary"
              size="small"
            >
              上传
            </el-button>
          </template>
          <template v-if="uploadDialog.status === 'uploading'">
            <el-button :loading="true" size="small" type="primary">
              上传中…
            </el-button>
          </template>
          <template v-if="uploadDialog.status === 'finish'">
            <el-button @click="closeUpload" size="small" type="primary">
              关闭
            </el-button>
          </template>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="420px"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="moveDialog.visible"
    >
      <div class="dialog-head">
        <div class="dialog-head-title">移动至</div>
        <div @click="closeMoveDialog" class="dialog-head-close"></div>
      </div>
      <div class="dialog-body padding">
        <el-select
          style="width: 100%"
          v-model="moveDialog.categoryId"
          placeholder="请选择素材分类"
          size="small"
        >
          <el-option
            v-for="(n, i) in moveDialog.categorys"
            :key="i"
            :value="n.id"
            :label="n.name"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-foot border">
        <el-button @click="closeMoveDialog" type="infor" size="small">
          取消
        </el-button>
        <el-button @click="moveConfirm" type="primary" size="small">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadPictureSource,
  updateCategorySource,
  updateSource,
  deleteSource,
  getSourceCategorys,
} from "@/api/course";
import { getSources, systemSwitch, canUpload } from "@/api/api";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      width: 135,
      // showType: "table",
      showType: "grid",
      timerange: "",
      total: 0,
      list: [],
      params: {
        keyword: "",
        total: 1,
        page: 1,
        pageSize: 60,
        categoryId: "",
        sort_by: "time_desc",
      },
      mediaViewer: {
        visible: false,
        images: [],
        index: 0,
      },
      uploadDialog: {
        visible: false,
        selecteds: [],
        status: "show",
      },
      selecteds: [],
      moveDialog: {
        visible: false,
        targets: [],
        categoryId: "",
        categorys: [],
        oldCategory: "",
      },
      isUploadVideoValue: -1,
      isCanUpload: true,
      show_storage: "",
      current_storage: "",
    };
  },
  props: {
    categoryId: {
      type: Number,
      default: null,
    },
    mode: {
      type: String,
      default: "normal",
    },
    isShowAlert: {
      type: Boolean,
      default: true,
    },
    // isCanUpload: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  watch: {
    selecteds: {
      handler() {
        this.$emit("select", this.selecteds);
      },
      immediate: true,
      deep: true,
    },
    categoryId: {
      handler() {
        this.params.categoryId = this.categoryId;
        this.handleCurrentChange(1);
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    // 获取上传视频黑名单
    console.log("isUploadVideo");
    if (this.isUploadVideoValue !== -1) {
      return this.isUploadVideoValue;
    }
    const user = this.$rrj.storage.get("_ukit");
    const res = await systemSwitch({
      user_id: user && user.id,
      include: "activity_upload_switch",
    });
    this.isUploadVideoValue = res.activity_upload_switch;

    const isCanUpload = await canUpload();
    // if (isCanUpload.result == "ok") {
    this.isCanUpload = isCanUpload.canUpload;
    this.current_storage = isCanUpload.current_storage;
    this.show_storage = isCanUpload.show_storage;

    // }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initLayout();
      }, 600);
    });
    this.params.categoryId = this.categoryId;
    this.loadData();
    this.$bus.$on("windowResize", () => {
      this.initLayout();
    });
  },
  methods: {
    pageToUpload() {
      this.$store.commit("uploads/setUploadLimit", true);
    },
    changeDateRange() {
      if (this.timerange) {
        this.params.start_at = this.timerange[0] + " 00:00:00";
        this.params.end_at = this.timerange[1] + " 23:59:59";
      } else {
        delete this.params.start_at;
        delete this.params.end_at;
      }
      this.handleCurrentChange(1);
      console.log("this.timerange", this.timerange);
    },
    async moveAllSource() {
      let res = await getSourceCategorys("picture");
      this.moveDialog = {
        visible: true,
        targets: [],
        categoryId: "",
        categorys: res.data,
        oldCategory: this.categoryId,
      };
    },
    editSource(source) {
      this.$prompt("请输入素材名称", "编辑素材", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: source.file_name,
      })
        .then(async ({ value }) => {
          console.log(value);
          const res = await updateSource(source.id, {
            file_name: value,
          });
          if (res.result === "ok") {
            this.loadData();
            this.$message.success("操作成功");
          } else {
            this.$message.success("操作失败");
          }
        })
        .catch(() => {});
    },
    async moveSource(source) {
      let res = await getSourceCategorys("picture");
      this.moveDialog = {
        visible: true,
        targets: [source],
        categoryId: "",
        categorys: res.data,
        oldCategory: "",
      };
    },
    async batchMoveSource() {
      let res = await getSourceCategorys("picture");
      this.moveDialog = {
        visible: true,
        targets: this.selecteds,
        categoryId: "",
        categorys: res.data,
        oldCategory: "",
      };
    },
    async moveConfirm() {
      if (this.moveDialog.targets.length === 0 && this.moveDialog.oldCategory) {
        await updateCategorySource(this.moveDialog.oldCategory, {
          categoryId: this.moveDialog.categoryId,
        });
      } else {
        for (let source of this.moveDialog.targets) {
          await updateSource(source.id, {
            category_id: this.moveDialog.categoryId,
          });
        }
      }

      this.loadData();
      this.$message.success("操作成功");
      this.closeMoveDialog();
      this.$bus.$emit("refreshSourceCategory");
    },
    closeMoveDialog() {
      this.moveDialog.visible = false;
      this.moveDialog.categoryId = "";
      this.moveDialog.oldCategory = "";
    },
    batchDeleteSource() {
      this.$confirm("确认要删除所选素材吗？", "删除素材", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          for (let source of this.selecteds) {
            await deleteSource(source.id);
          }
          this.loadData();
          this.$bus.$emit("refreshSourceCategory");
          this.$message.success("操作成功");
        })
        .catch(() => {});
    },
    deleteSource(source) {
      this.$confirm("确认要删除这个素材吗？", "删除素材", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const res = await deleteSource(source.id);
          if (res.result === "ok") {
            this.loadData();
            this.$bus.$emit("refreshSourceCategory");
            this.$message.success("操作成功");
          } else {
            this.$message.success("操作失败");
          }
        })
        .catch(() => {});
    },
    initLayout() {
      if (this.mode === "normal") {
        const divElement = document.getElementById("gridList");
        const width = divElement?.clientWidth;
        let widthFloor = Math.floor((width - 8) / (135 + 16));
        this.width = Math.floor((width - 8) / widthFloor - 16);
      }
    },
    handleSelectionChange(res) {
      this.selecteds = this.$rrj.deepClone(res);
    },
    gridChange(res, index) {
      this.list[index].selected = res;
      this.selecteds = this.$rrj.deepClone(
        this.list.filter((item) => item.selected === true)
      );
    },
    closeMediaViewer() {
      this.mediaViewer.visible = false;
    },
    showMediaViewer(index) {
      this.mediaViewer.visible = true;
      this.mediaViewer.index = index;
    },
    changeShowType(type) {
      this.showType = type;
      if (type === "table") {
        this.$nextTick(() => {
          let ids = this.selecteds.map((item) => item.id);
          let rows = this.list.filter((item) => ids.includes(item.id));
          rows.forEach((row) => {
            this.$refs.listTable.toggleRowSelection(row);
          });
        });
      }
      if (type === "grid") {
        let ids = this.selecteds.map((item) => item.id);
        this.list.forEach((item) => {
          if (ids.includes(item.id)) {
            item.selected = true;
          }
        });
      }
    },
    closeUploadDialog() {
      if (this.uploadDialog.status === "uploading") {
        this.$message.error("正在上传中，请稍后关闭");
        return;
      }
      this.uploadDialog = {
        visible: false,
        selecteds: [],
        status: "show",
      };
    },
    showUploadDialog() {
      this.uploadDialog = {
        visible: true,
        selecteds: [],
        status: "show",
      };
      console.log("showUploadDialog");
    },
    closeUpload() {
      this.closeUploadDialog();
      this.loadData();
    },
    async startUpload() {
      this.uploadDialog.status = "uploading";
      for (let item of this.uploadDialog.selecteds) {
        let file = item.file;
        item.status = 1;
        await uploadPictureSource(
          this.categoryId,
          "picture",
          file,
          JSON.stringify(item.size)
        );
        item.status = 100;

        // 检查是否全部完成
        let finished = this.uploadDialog.selecteds.filter((item) => {
          return item.status === 100;
        });
        if (finished.length === this.uploadDialog.selecteds.length) {
          this.uploadDialog.status = "finish";
        }
      }
    },
    async uploadFile(file) {
      if (this.isUploadVideoValue === "0") {
        // 关闭所有现有的通知
        this.$message.closeAll(); // 关闭所有消息
        return this.$message.error(
          "账号上传额度已用尽，升级为高级讲师后可继续上传"
        );
      }

      let url = await file.getBlob();
      let res = await this.getImageSize(url);
      this.uploadDialog.selecteds.push({
        url,
        file,
        status: 0,
        size: res,
      });
    },
    changeSort(sortBy) {
      this.params.sort_by = sortBy;
      this.handleCurrentChange(1);
    },
    search() {
      this.handleCurrentChange(1);
    },
    reset() {
      delete this.params.keyword;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(current) {
      this.params.page = current;
      this.selected = [];
      this.loadData();
    },
    async loadData() {
      console.log("picture", this.params);
      this.mediaViewer.images = [];
      let res = await getSources("picture", this.params);
      for (let item of res.rows) {
        this.mediaViewer.images.push(item.url);
        if (item.file_info) {
          let info = JSON.parse(item.file_info);
          item.info = `${info.width} × ${info.height}`;
        } else {
          item.info = "-";
        }
      }
      this.list = res.rows;
      this.total = res.totalCount;
      console.log(res);
    },
  },
};
</script>

<style lang="scss" scoped>
.show-tabs {
  width: 152px;
  height: 32px;
  padding: 4px;
  margin-left: 16px;
  border-radius: 16px;
  position: relative;
  box-sizing: border-box;
  background-color: #f7f8fa;

  .tab-bar {
    width: 70px;
    height: 24px;
    border-radius: 12px;
    background-color: #ffffff;
    transition: all 0.2s;

    &.table {
      transform: translateX(70px);
    }
  }

  .tab-block {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 140px;
    height: 24px;
    display: flex;
    align-items: center;

    .tab-item {
      width: 70px;
      text-align: center;
      line-height: 24px;
      font-size: 12px;
      color: #686767;
      cursor: pointer;

      &:hover {
        color: #0366ff;
      }

      &.active {
        color: #0366ff;
      }
    }
  }
}

.upload-dialog {
  width: 100%;
  height: 70vh;
  border-radius: 16px;
  background-color: #ffffff;

  display: flex;
  flex-direction: column;
}

.upload-files {
  display: flex;
  flex-wrap: wrap;

  .file-item {
    width: 120px;
    height: 120px;
    margin-right: 16px;
    margin-bottom: 16px;
    position: relative;
    border-radius: 8px;

    .file-item-loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 120px;
      height: 120px;
      border-radius: 8px;
      background-color: rgba($color: #000000, $alpha: 0.6);

      display: inline-flex;
      align-items: center;
      justify-content: center;

      font-size: 20px;
      color: #ffffff;
    }

    .file-item-success {
      position: absolute;
      top: 0;
      left: 0;
      width: 120px;
      height: 120px;
      border-radius: 8px;
      background-color: rgba($color: #000000, $alpha: 0.6);

      display: inline-flex;
      align-items: center;
      justify-content: center;

      font-size: 20px;
      color: #ffffff;
    }

    &:nth-child(6n) {
      margin-right: 0;
    }

    .file-item-img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      background-color: #f7f8fa;
    }
  }
}

.dialog-upload-btn {
  margin-right: 10px;
}
</style>
